import { Component, OnInit } from "@angular/core";
import { NgForm } from "@angular/forms";
import { HrserviceService } from "../../hr-manager/service/hrservice.service";
import { Router, ActivatedRoute } from "@angular/router";
import { ConfirmationDialogComponent } from "../../expense-manager/confirmation-dialog/confirmation-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { AddItemDialogComponent } from '../shared/add-item-dialog/add-item-dialog.component';
import { AddDialogConfigs } from '../shared/add-item-dialog/add-dialog-configs';
import { HolidayDialogComponent } from '../holiday-dialog/holiday-dialog.component';
import { ExcelService } from "src/app/core/services/excel.service";

@Component({
  selector: "app-holiday-list",
  templateUrl: "./holiday-list.component.html",
  styleUrls: ["./holiday-list.component.css", "../shared/hr-table-styles.scss"],
  providers: [ExcelService]
})
export class HolidayListComponent2 implements OnInit {
  headingHoliday: string = "List of Holiday";
  searchQuery: string = '';
  p: number;
  holidayDate: Date;
  holidayname: string;
  holidaytype: string;
  selectedButton: string;
  selectedlist:string;
  holidaydata: any;
  filteredHolidayData: any[] = [];
  formdata: any;
  holidayEventType:any;
  selectedEventType:string='offline';
  eventDescription: string = '';
   date:Date; 
   day:string; 
   month:string;
   year:Number ;
   formattedDate:String;
   currentDate:String;

  constructor(private hrservice: HrserviceService,private router: Router,
    private route: ActivatedRoute,public dialog: MatDialog,
    private excelService: ExcelService) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((queryParams) => {
      this.selectedButton = queryParams.selectedlist || 'all';
    
    });
    this.handleButtonClick(this.selectedButton);
  
  }

  // Header functionality methods
  onSearchInput(searchTerm: string): void {
    this.searchQuery = searchTerm;
    this.applySearchFilter();
  }

  applySearchFilter(): void {
    if (!this.holidaydata) {
      this.filteredHolidayData = [];
      return;
    }

    if (!this.searchQuery || this.searchQuery.trim() === '') {
      // If no search term, show all data
      this.filteredHolidayData = [...this.holidaydata];
    } else {
      // Filter based on search term
      const searchLower = this.searchQuery.toLowerCase().trim();
      this.filteredHolidayData = this.holidaydata.filter((holiday: any) => {
        const title = holiday.title ? holiday.title.toLowerCase() : '';
        const type = holiday.type ? holiday.type.toLowerCase() : '';
        const date = holiday.date ? holiday.date.toString() : '';
        
        return title.includes(searchLower) || 
               type.includes(searchLower) || 
               date.includes(searchLower);
      });
    }
  }

  addHoliday(): void {
    this.openAddHolidayDialog();
  }

  openFilterDialog(): void {
    // Implement filter dialog logic here
    console.log('Opening filter dialog');
  }

  // Open add holiday dialog
  openAddHolidayDialog(): void {
    const dialogRef = this.dialog.open(HolidayDialogComponent, {
      width: '800px',
      disableClose: true,
      data: { type: 'create' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log('New holiday data:', result);
        // Call your existing API to add the holiday
        this.hrservice.addHolidayList(result).subscribe((res: any) => {
          alert(res.message);
          this.ngOnInit(); // Refresh the list
        });
      }
    });
  }

  // Save new holiday
  saveHoliday(holidayData: any): void {
    console.log('Saving holiday:', holidayData);
    // Implement API call here
    // this.hrservice.addHolidayList(holidayData).subscribe(response => {
    //   // Refresh holiday list
    //   this.holidayList();
    // });
  }
  _addHoliday(data: NgForm) {
    //console.log(data.value);
    this.date = data.value.holidaydate;
    this.day = String(this.date.getDate()).padStart(2, "0");
    this.month = String(this.date.getMonth() + 1).padStart(2, "0");
    this.year = this.date.getFullYear();
    this.formattedDate = `${this.year}-${this.month}-${this.day}`;
      //console.log(formattedDate);
      
    // Base data for all holiday types
    this.formdata = {
      date: this.formattedDate,
      name: data.value.holidayname,
      type: data.value.holidaytype
    };

    // Only add event-specific fields if holiday type is "Event" (value "3")
    if (data.value.holidaytype === '3') {
      this.formdata = {
        ...this.formdata,
        desc: data.value.eventdescription,
        location: data.value.eventlocation,
        status: data.value.eventtype,
        start_time: data.value.eventstarttime,
        end_time: data.value.eventendtime
      };
    }

    try {
      this.hrservice.addHolidayList(this.formdata).subscribe((res: any) => {
        alert(res.message);
         this.ngOnInit();
      });
    } catch (error) {
      console.error("An error occurred:", error);
      throw new Error("Something went wrong. Please try again later.");
    }
  }

  openDeleteConfirmation(holidayid:number): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this._deleteHoliday(holidayid )
      }
    });
  }

  _deleteHoliday(holidayid:number) {
    
    try {
      this.hrservice
        .deleteHolidayList(holidayid)
        .subscribe((res: any) => {
          // console.log(res.status);

          if (res.status) {

            alert(res.message);
            //window.location.reload();
            this.ngOnInit();
          }
        });
    } catch (error) {
      console.error("An error occurred:", error);
      throw new Error("Something went wrong. Please try again later.");
    }
  }
  resetForm(data: NgForm) {
    data.resetForm();
    this.selectedEventType = 'offline';
  }

  onButtonClick(button: string) {
   this.handleButtonClick(button);
  }

  private handleButtonClick(button:string) {
    switch (button) {
      case 'all':
        this._allHoliday(button);
        break;
      case 'upcoming':
        this._upcomingHoliday(button);
        break;
      case 'past':
        this._pastHoliday(button);
        break;
      default:
        this._allHoliday(button);
    }
  }
  _allHoliday(button:string) {
    this.p = 1;
    try {
      this.hrservice.holidayList().subscribe((res: any) => {
        console.log(res.data);
        this.holidaydata = res.data;
        this.applySearchFilter();
        this.selectedlist = button;
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: {selectedlist: button },
          queryParamsHandling: 'merge',
        });
      });
    } catch (error) {
      console.error("An error occurred:", error);
      throw new Error("Something went wrong. Please try again later.");
    }
    console.log("all holiday");
  }

  _upcomingHoliday(button:string) {
    this.p = 1;
    try {
      this.hrservice.holidayList().subscribe((res: any) => {
        this.selectedlist= button;
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: {selectedlist: button },
          queryParamsHandling: 'merge',
        });
        console.log(res.data);
        this.currentDate = new Date().toJSON().slice(0, 10);
        // console.log(this.currentDate);

        this.holidaydata = res.data.filter((res) => {
          console.log(res.date);
          const holidayDate = res.date;
          // console.log(holidayDate);
          return holidayDate >= this.currentDate;
        }).reverse();
        this.applySearchFilter();
        this.applySearchFilter();
        // console.log(this.holidaydata);
      });
    } catch (error) {
      console.error("An error occurred:", error);
      throw new Error("Something went wrong. Please try again later.");
    }
  }

  _pastHoliday(button:string) {
    this.p = 1;
    try {
      this.hrservice.holidayList().subscribe((res: any) => {
        this.selectedlist= button;
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: { selectedlist: button },
          queryParamsHandling: 'merge',
        });
        console.log(res.data);
        this.currentDate = new Date().toJSON().slice(0, 10);
        // console.log(this.currentDate);

        this.holidaydata = res.data.filter((res) => {
          // console.log(res.date);
          const holidayDate = res.date;
          console.log(holidayDate);
          return holidayDate < this.currentDate;
        });
        this.applySearchFilter();
        this.applySearchFilter();
        // console.log(this.holidaydata);
      });
    } catch (error) {
      console.error("An error occurred:", error);
      throw new Error("Something went wrong. Please try again later.");
    }
  }

  //  day to date function
  getDayForDate(date: string): string {
    const dayNames = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    const [year, month, day] = date.split("-").map(Number);
    const dateObject = new Date(year, month - 1, day);
    const dayIndex = dateObject.getDay();
    return dayNames[dayIndex];
  }

  exportHolidays(): void {
    const holidays = (this.filteredHolidayData || []).map((holiday) => ({
      Name: holiday.title,
      Type: holiday.type,
      Day: this.getDayForDate(holiday.date),
      Date: holiday.date,
      Description: holiday.desc,
      Location: holiday.location,
      Status: holiday.status
    }));

    if (holidays.length === 0) {
      this.hrservice.holidayList().subscribe((res: any) => {
        const list = (res?.data || []).map((holiday) => ({
          Name: holiday.title,
          Type: holiday.type,
          Day: this.getDayForDate(holiday.date),
          Date: holiday.date,
          Description: holiday.desc,
          Location: holiday.location,
          Status: holiday.status
        }));
        this.excelService.exportAsExcelFile(list, `holidays_${this.getExportDate()}`);
      });
      return;
    }

    this.excelService.exportAsExcelFile(holidays, `holidays_${this.getExportDate()}`);
  }

  private getExportDate(): string {
    return new Date().toISOString().slice(0, 10);
  }
}
